export const tableHeaders = [
  'ID',
  'User Email',
  'Game Name',
  'Action Type',
  'Amount',
  'Amount Type',
  'Before Balance',
  'After Balance',
  // 'Status',
  'Created At'
]

export const transactionType = [
  { label: 'Select Action Type', value: 'all' },
  { label: 'Bet', value: 'bet' },
  { label: 'Win', value: 'win' },
  { label: 'RollBack', value: 'rollback' },
  // { label: 'Pre RollBack', value: 'rollbackbeforebetwin' },
  // { label: 'Free Spin', value: 'freespins' }
]

export const statusType = [
  { label: 'All', value: 'all' },
  { label: 'Pending', value: 'pending' },
  { label: 'Complete', value: 'completed' },
  { label: 'Failed', value: 'failed' },
  { label: 'RollBack', value: 'rollback' }
]

export const AMOUNT_TYPE = {
  0: 'Cash',
  1: 'Non Cash',
  2: 'Cash and Non Cash'
}

export const tableCasinotransactionColumns = [
  { label: 'ID', value: 'casinoTransactionId', Header: 'ID', accessor: 'casinoTransactionId' },
  { label: 'User Email', value: 'email', Header: 'User Email', accessor: 'email' },
  { label: 'Game Name', value: 'gameIdentifier', Header: 'Game Name', accessor: 'gameIdentifier' },
  { label: 'Action Type', value: 'actionType', Header: 'Action Type', accessor: 'actionType' }, // Optional
  { label: 'Bet Amount', value: 'amount', Header: 'Bet Amount', accessor: 'amount' },
  { label: 'Before Balance', value: 'beforeBalance', Header: 'Before Balance', accessor: 'beforeBalance' },
  { label: 'After Balance', value: 'afterBalance', Header: 'After Balance', accessor: 'afterBalance' },
  // { label: 'Bonus Money', value: 'nonCashAmount', Header: 'Bonus Money', accessor: 'nonCashAmount' }, // Optional
  // { label: 'Status', value: 'status', Header: 'Status', accessor: 'status' },
  { label: 'Created At', value: 'createdAt', Header: 'Created At', accessor: 'createdAt' }
];
